export const setLocalStore = (key, data) => {
    localStorage.setItem(key, data);
};
export const getLocalStore = (key) => {
    const token = localStorage.getItem(key);
    return JSON.parse(token);
};
export const clearLocal = () => {
    localStorage.clear();
};
export const getLocalStoreString = (key) => {
    const stringData = localStorage.getItem(key);
    return stringData;
};
export const setLocalStoreString = (key, data) => {
    localStorage.setItem(key, data)
};

export const getQueryParams = (location, key) => {
    const queryParameters = new URLSearchParams(location.search)
    return queryParameters.get(key)
}